import { ColDef } from 'ag-grid-community';
import {
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createStatusBadgeCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';

export const recyclingProductListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createTypoCol({
    field: 'category',
    size: 'lg',
    headerName: '수거 품목 명',
  }),
  createStatusBadgeCol({
    field: 'isEventProduct',
    type: 'isApplied',
    size: 'sm',
    headerName: '이벤트 여부',
  }),
  createStatusBadgeCol({
    field: 'isExposed',
    type: 'isExposed',
    size: 'sm',
    headerName: '노출 여부',
  }),
  createDetailButtonColV2(onDetailClick),
];
